// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated-gradient-text {
  position: relative;
  margin: 0 auto;
  display: flex;
  max-width: fit-content;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 1.25rem;
  font-weight: 500;
  backdrop-filter: blur(10px);
  transition: box-shadow 0.5s ease-out;
  overflow: hidden;
  cursor: pointer;
}

.animated-gradient-text.with-border {
  padding: 0.35rem 0.75rem;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  z-index: 0;
  pointer-events: none;
}

.gradient-overlay::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  border-radius: inherit;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #060010;
  z-index: -1;
}

.text-content {
  display: inline-block;
  position: relative;
  z-index: 2;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/ui/GradientText.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB","sourcesContent":[".animated-gradient-text {\n  position: relative;\n  margin: 0 auto;\n  display: flex;\n  max-width: fit-content;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border-radius: 1.25rem;\n  font-weight: 500;\n  backdrop-filter: blur(10px);\n  transition: box-shadow 0.5s ease-out;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.animated-gradient-text.with-border {\n  padding: 0.35rem 0.75rem;\n}\n\n.gradient-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: inherit;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.gradient-overlay::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: inherit;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #060010;\n  z-index: -1;\n}\n\n.text-content {\n  display: inline-block;\n  position: relative;\n  z-index: 2;\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
